export enum ConsumptionUnitType {
  M3 = 'm³',
  KWH = 'kWh',
  HCU = 'HCU',
}
